/** The bank statements of ING (F37): what the API answers (amounts, balances and the other side's account may be cut by field rights). */
export const BANK_RESOURCE = 'bank.statements';
export const BANK_KEY = ['bank'] as const;

export type BankAccount = { id: string; iban: string; name: string; currency: string; version: number };

export type Statement = {
  id: string;
  accountId: string;
  iban: string;
  source: 'upload' | 'folder' | 'auto';
  format: 'camt053' | 'mt940';
  /** Absent when the role may not open the original file (it shows every hidden amount and account). */
  fileId?: string;
  fileName: string;
  periodFrom: string;
  periodTo: string;
  openingGrosze?: number;
  closingGrosze?: number;
  entries: number;
  newEntries: number;
  importedBy: string | null;
  importedAt: string;
};

export type Transaction = {
  id: string;
  accountId: string;
  bookingDate: string;
  valueDate: string | null;
  amountGrosze?: number;
  currency: string;
  counterpartyName: string;
  counterpartyIban?: string | null;
  title: string;
  bankRef: string | null;
  statementId: string;
};

export type UploadResult = {
  filename: string;
  status: 'imported' | 'already_imported' | 'error';
  statementId: string | null;
  entries: number;
  newEntries: number;
  code?: string;
  message?: string;
};

export type InboxStatus = { dir: string; lastRunAt: string | null; lastError: string | null; waiting: number };
